<template>
  <div class="team">
    <v-container >
      <template>
      <loading
          :label="label">
      </loading>
      </template>
      <v-layout row wrap>
         <v-flex
            sm12
            xs12
            md12
            lg12
          >
          <template>
            <v-card>
              <v-toolbar color="#008a43" flat><h3 class="white--text">Công cụ</h3></v-toolbar>
               <v-card-title>
                 <v-row>
                  <v-col
                        cols="12"
                        sm="6"
                        xs="12"
                        md="4"
                        lg="4"
                    >
                    <v-text-field
                      v-model="filter.BienSoXe"
                      :rules="rules.LicensePlates"
                      counter="11"
                      label="Biển số"
                      hint="Tìm kiếm bằng biển số xe"
                      persistent-hint
                      outlined
                      persistent-placeholder
                    ></v-text-field>
                 </v-col>
                  <v-col
                        cols="12"
                        sm="6"
                        xs="12"
                        md="4"
                        lg="4"
                    >
                    <v-select
                      v-model="filter.Tram"
                      :items="listStations"
                      label="Trạm"
                      item-value="StationsID"
                      item-text="StationsName"
                      outlined
                    ></v-select>
                 </v-col>
                  <v-col
                        cols="12"
                        sm="6"
                        xs="12"
                        md="4"
                        lg="4"
                    >
                    <v-menu
                      v-model="menuDate"
                      :close-on-content-click="false"
                      max-width="290"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="computedDateFormattedMomentjs"
                          clearable
                          label="Ngày kết thúc: "
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="filter.NgayKetThuc = null"
                          hint="Tìm kiếm theo thời gian"
                          persistent-hint
                          outlined
                          persistent-placeholder
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filter.NgayKetThuc"
                        @change="menuDate = false"
                      ></v-date-picker>
                    </v-menu>
                 </v-col>
                 <v-col
                    cols="6"
                    sm="6"
                    xs="6"
                    md="4"
                    lg="1"
                  >
                  <v-btn-toggle>
                    <v-btn color="#008a43" class="white--text" @click=TimKiem>Tìm kiếm <v-icon right>mdi mdi-clipboard-text-search-outline</v-icon> </v-btn>
                  </v-btn-toggle>
                 </v-col>
                 <v-col
                    cols="6"
                    sm="6"
                    xs="6"
                    md="4"
                    lg="1"
                  >
                 <v-file-input
                      v-model="file"
                      truncate-length="15"
                      label="Import Excel"
                    ></v-file-input>
                      <xlsx-read :file="file">
                        <xlsx-json v-on:parsed=ImportXLSX>
                          <!-- <template #default="{collection}">
                            <div>
                              {{ collection }}
                            </div>
                          </template> -->
                        </xlsx-json>
                      </xlsx-read>
                 </v-col>
                 </v-row>
              </v-card-title>              
            </v-card>
            <br />
          </template>
         </v-flex>
         <v-flex
            sm12
            xs12
            md12
            lg12
          >
          <template>
            <v-card>
              <v-toolbar color="#008a43" flat><h3 class="white--text">Danh sách vé tháng</h3></v-toolbar>
              <v-tabs
                v-model="tab"
                background-color="#f5f5f5"
                centered
                
                icons-and-text
              >
               <v-tabs-slider></v-tabs-slider>
                  <v-tab href="#tab-1">
                    <v-icon>mdi-ticket</v-icon>
                    <p class="black--text">Danh sách vé tháng</p>
                  </v-tab>

                  <v-tab href="#tab-2" v-if=listTicketExpireCount>
                    <v-badge
                      color="error"
                      overlap
                      :content="listTicketExpireCount"
                      v-if="listTicketExpireCount"
                    >
                      <v-icon>mdi-phone</v-icon>
                    </v-badge>
                    <v-icon v-else>mdi-phone</v-icon>
                    <p class="black--text">Sắp hết hạn</p>
                  </v-tab>
                </v-tabs>
               <v-tabs-items v-model="tab">
                  <v-tab-item
                    key="1"
                    value="tab-1"
                  >
                    <v-card-title>
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col
                          cols="12"
                          md="6"
                          lg="4"
                        >
                          <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Tìm kiếm nhanh"
                            single-line
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-data-table
                      :loading="loading"
                      :headers="headers"
                      :items="itemsWithIndex"
                      :search="search"
                      loading-text="Đang tải dữ liệu..."
                      :footer-props="{itemsPerPageText: 'Dữ liệu mỗi trang','items-per-page-options':[10,20,30,40,50]}"
                      :items-per-page="20"
                    >
                    <template v-slot:no-data>
                      <br />
                      <v-alert
                        border="right"
                        colored-border
                        type="warning"
                      >
                        <v-btn text color="warning">KHÔNG CÓ DỮ LIỆU</v-btn>
                      </v-alert>
                    </template>
                    <template v-slot:[`item.GiaTien`]="{ item }">
                      <v-btn
                        text
                        small
                      >
                          {{new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(item.GiaTien)}}
                        </v-btn>
                    </template>
                    <template v-slot:[`item.NgayBan`]="{ item }">
                      <v-btn
                        text
                        small
                      >
                          {{moment(item.NgayBan).tz("Asia/Bangkok").format("DD-MM-YYYY HH:mm:ss")}}
                        </v-btn>
                    </template>
                    <template v-slot:[`item.NgayBatDau`]="{ item }">
                      <v-btn
                        text
                        small
                      >
                          {{moment(item.NgayBatDau).tz("Asia/Bangkok").format("DD-MM-YYYY")}}
                        </v-btn>
                    </template>
                    <template v-slot:[`item.NgayKetThuc`]="{ item }">
                      <v-btn
                        text
                        small
                      >
                          {{moment(item.NgayKetThuc).tz("Asia/Bangkok").format("DD-MM-YYYY")}}
                        </v-btn>
                    </template>
                    <template v-slot:[`item.LoaiVe`]="{ item }">
                      <v-btn
                        text
                        small
                      >
                          {{KiemTraLoaiVe(item.LoaiVe)}}
                        </v-btn>
                    </template>
                    <template v-slot:[`item.Id`]="{ item }">
                          <Manager :ListStations="listStationsOnly" :ListTypeOfTickets="listTypeOfTickets" :Rules="rules" :ShowButton=false ref="UpdateItem" :isUpdated.sync="isUpdated" />
                          <ControlButton :Item="item" :EditFunc="ChinhSua" :DeleteFunc="Xoa" EditText="Ghi chú"/>
                    </template>
                    </v-data-table>
                  </v-tab-item>
                  <v-tab-item
                    key="2"
                    value="tab-2"
                  >
                    <v-card-title>
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col
                          cols="12"
                          md="6"
                          lg="4"
                        >
                          <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Tìm kiếm nhanh"
                            single-line
                            hide-details
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-data-table
                      :loading="loading"
                      :headers="headers"
                      :items="itemsExpireWithIndex"
                      :search="search"
                      loading-text="Đang tải dữ liệu..."
                      :footer-props="{itemsPerPageText: 'Dữ liệu mỗi trang','items-per-page-options':[10,20,30,40,50]}"
                      :items-per-page="20"
                    >
                    <template v-slot:no-data>
                      <br />
                      <v-alert
                        border="right"
                        colored-border
                        type="warning"
                      >
                        <v-btn text color="warning">KHÔNG CÓ DỮ LIỆU</v-btn>
                      </v-alert>
                    </template>
                    <template v-slot:[`item.GiaTien`]="{ item }">
                      <v-btn
                        text
                        small
                      >
                          {{new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(item.GiaTien)}}
                        </v-btn>
                    </template>
                    <template v-slot:[`item.NgayBan`]="{ item }">
                      <v-btn
                        text
                        small
                      >
                          {{moment(item.NgayBan).tz("Asia/Bangkok").format("DD-MM-YYYY HH:mm:ss")}}
                        </v-btn>
                    </template>
                    <template v-slot:[`item.NgayBatDau`]="{ item }">
                      <v-btn
                        text
                        small
                      >
                          {{moment(item.NgayBatDau).tz("Asia/Bangkok").format("DD-MM-YYYY")}}
                        </v-btn>
                    </template>
                    <template v-slot:[`item.NgayKetThuc`]="{ item }">
                      <v-btn
                        text
                        small
                      >
                          {{moment(item.NgayKetThuc).tz("Asia/Bangkok").format("DD-MM-YYYY")}}
                        </v-btn>
                    </template>
                    <template v-slot:[`item.LoaiVe`]="{ item }">
                      <v-btn
                        text
                        small
                      >
                          {{KiemTraLoaiVe(item.LoaiVe)}}
                        </v-btn>
                    </template>
                    <template v-slot:[`item.Id`]="{ item }">
                          <Manager :ListStations="listStationsOnly" :ListTypeOfTickets="listTypeOfTickets" :Rules="rules" :ShowButton=false ref="UpdateItem" :isUpdated.sync="isUpdated" />
                          <ControlButton :Item="item" :EditFunc="ChinhSua" :DeleteFunc="Xoa" EditText="Ghi chú"/>
                    </template>
                    </v-data-table>
                  </v-tab-item>
               </v-tabs-items>
            </v-card>
          </template>
         </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import loading from 'vue-full-loading'
import { XlsxRead, XlsxJson } from "vue-xlsx"
import Manager from './../components/TicketManager.vue'
import ControlButton from './../components/ControlButton.vue'
export default {
  name: 've-thang',
  components: {
    Manager,
    ControlButton,
    XlsxRead,
    XlsxJson,
    loading
  },
  computed: {
    listTicketExpireCount(){
      return this.listTicketExpire.length;
    },
    listStationsOnly(){
      const newArray = [].concat(this.listStations);
      return newArray.slice(1);
    },
    computedDateFormattedMomentjs () {
        return this.filter.NgayKetThuc ? this.moment(this.filter.NgayKetThuc).tz("Asia/Bangkok").format("DD-MM-YYYY") : '';
      },
    itemsWithIndex: function(){
        return this.items.map(
          (items, index) => ({
            ...items,
            index: index + 1
          }))
      },
    itemsExpireWithIndex: function(){
        return this.listTicketExpire.map(
          (items, index) => ({
            ...items,
            index: index + 1
          }))
      }
  },
  methods: {
    KiemTraLoaiVe: function(loaive){
      return this.listTypeOfTickets.find(element=>{
        if(element.TypeOfTicketID === loaive) return element;
      }).TypeOfTicketName;
    },
    ImportXLSX: function(event){
      this.show = true;
      this.$Request.post(`/ticket/import`,event).then(response => {
          const json = response.data;
          if(json.success === true)
          {
            //this.$refs.UpdateItem.EditItem(json.data);
            this.file = null;
            const msg = json.msg || "Đã import thành công !";
            this.$swal.fire({
                position: 'center',
                icon: 'success',
                title: msg,
                showConfirmButton: false,
                timer: 1500
            });
            this.LayDulieu();
          }else{
            const msg = json.error || "Không tải được dữ liệu !!!";
            this.$swal.fire({
                position: 'center',
                icon: 'error',
                title: msg,
                showConfirmButton: false,
                timer: 1500
            });
          }
      }).catch((error) =>{
          console.log(error);
          this.$swal.fire({
              position: 'center',
              icon: 'error',
              title: "Không tải được dữ liệu !!!",
              showConfirmButton: false,
              timer: 1500
          });
        }).finally(()=>{
        this.show = false;
      });
    },
    onChange: function(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },
    ChinhSua: function(item){
      if(!item.Id)
      {
        return;
      }
      this.loading = true;
      this.$Request.get(`/ticket/${item.Id}`).then(response => {
          const json = response.data;
          if(json.success === true)
          {
            this.$refs.UpdateItem.EditItem(json.data);
          }else{
            const msg = json.error || "Không tải được dữ liệu !!!";
            this.$swal.fire({
                position: 'center',
                icon: 'error',
                title: msg,
                showConfirmButton: false,
                timer: 1500
            });
          }
      }).catch((error) =>{
          console.log(error);
          this.$swal.fire({
              position: 'center',
              icon: 'error',
              title: "Không tải được dữ liệu !!!",
              showConfirmButton: false,
              timer: 1500
          });
        }).finally(()=>{
        this.loading = false;
      });
    },
    Xoa: async function(item){
      if(!item.TicketId)
      {
        return;
      }
      const result = await this.$swal.fire({
        title: 'Bạn có chắc chắn?',
        text: "Hành động này sẽ không thể phục hồi được dữ liệu !!!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Hủy',
        confirmButtonText: 'Xác nhận xóa'
      });
      if(result.isConfirmed === false)
      {
        return;
      }
      this.loading = true;
      this.$Request.delete(`/ticket/${item.TicketId}`).then(response => {
          const json = response.data;
          if(json.success === true)
          {
            this.LayDulieu();
            const msg = response.data.msg || "Đã xóa thành công !";
            this.$swal.fire({
                position: 'center',
                icon: 'success',
                title: msg,
                showConfirmButton: false,
                timer: 1500
            });
          }else{
            const msg = json.error || "Không tải được dữ liệu !!!";
            this.$swal.fire({
                position: 'center',
                icon: 'error',
                title: msg,
                showConfirmButton: false,
                timer: 1500
            });
          }
      }).catch((error) =>{
          console.log(error);
          this.$swal.fire({
              position: 'center',
              icon: 'error',
              title: "Không tải được dữ liệu !!!",
              showConfirmButton: false,
              timer: 1500
          });
        }).finally(()=>{
        this.loading = false;
      });
    },
    TimKiem: function(){
      this.loading = true;
      this.$Request.post('/ticket',this.filter).then(response => {
          this.items = response.data.data;
      }).finally(()=>{
        this.loading = false;
      });
    },
    LayDulieu: function(){
      this.loading = true;
      this.$Request.get(`/ticket`).then(response => {
          this.listTypeOfTickets = response.data.listTypeOfTickets;
          this.listStations = this.listStations.concat(response.data.listStations);
          this.listTicketExpire = response.data.listTicketExpire;
          this.items = response.data.listTicket;
      }).catch(() =>{
          this.$swal.fire({
              position: 'center',
              icon: 'error',
              title: "Không tải được dữ liệu !!!",
              showConfirmButton: false,
              timer: 1500
          });
        }).finally(()=>{
        this.loading = false;
      });
    },
  },
  watch: {
    isUpdated:function(val)
    {
      if(val === true)
      {
        this.isUpdated = undefined;
        this.LayDulieu();
      }
    },
    parsed:function(val){
      console.log(val);
    }
  },
  data : () => ({
    tab: null,
    show: false,
    label: 'Dữ liệu đang được tải...',
    parsed: undefined, 
    file: null,
    menuDate: false,
    isUpdated: undefined,
    loading: false,
    addDefault:{

    },
    filter:{
      BienSoXe: "",
      Tram: null,
      NgayKetThuc: null,
    },
    rules: {
      LicensePlates: [v => (v.length <= 11 && v.length >= 7) || 'BKS phải từ 7-11 kí tự'],
      Required: [v => !!v || 'Điền dữ liệu vào !!!']
    },
    listTypeOfTickets: [],
    listStations: [{StationsID:null,StationsName:"Tất Cả"}],
    listTicketExpire: [],
    items: [],
    search: "",
    headers: [
        { text: 'STT', align: 'center', sortable: true,value: 'index',width:"5%",class:"grey lighten-2 primary--text" },
        { text: 'Đoạn/Trạm', align: 'center', sortable: false,value: 'station.StationsName',width:"20%",class:"grey lighten-2 black--text" },
        { text: 'Biển số', align: 'center', sortable: true,value: 'BienSoXe',width:"10%",class:"grey lighten-2 black--text"},
        { text: 'Loại vé', align: 'center', sortable: false,value: 'LoaiVe',width: "10%",class:"grey lighten-2 black--text" },
        { text: 'Giá tiền', align: 'center', sortable: false,value: 'GiaTien',width: "5%",class:"grey lighten-2 black--text" },
        { text: 'Ngày bán', align: 'center', sortable: false,value: 'NgayBan',width: "10%",class:"grey lighten-2 black--text" },
        { text: 'Ngày bắt đầu', align: 'center', sortable: false,value: 'NgayBatDau',width: "10%",class:"grey lighten-2 black--text" },
        { text: 'Ngày kết thúc', align: 'center', sortable: false,value: 'NgayKetThuc',width: "10%",class:"grey lighten-2 black--text" },
        { text: 'Ghi chú', align: 'center', sortable: false,value: 'GhiChu',width: "20%",class:"grey lighten-2 black--text" },
        { text: 'Thao tác', align: 'center', sortable: false,value: 'Id',width: "10%",class:"grey lighten-2 black--text" },
    ],
  }),
  mounted(){
    this.LayDulieu();
  }
}
</script>
